
import netteForms from 'nette-forms';
window.Nette = netteForms;

Nette.validateControlTimer = {};

Nette.validateForm = function(sender, onlyCheck) {
	var form = sender.form || sender,
		scope = false;

	Nette.formErrors = [];

	if (form['nette-submittedBy'] && form['nette-submittedBy'].getAttribute('formnovalidate') !== null) {
		var scopeArr = JSON.parse(form['nette-submittedBy'].getAttribute('data-nette-validation-scope') || '[]');
		if (scopeArr.length) {
			scope = new RegExp('^(' + scopeArr.join('-|') + '-)');
		} else {
			Nette.showFormErrors(form, []);
			return true;
		}
	}

	var radios = {}, i, elem;

	for (i = 0; i < form.elements.length; i++) {
		elem = form.elements[i];

		if (elem.tagName && !(elem.tagName.toLowerCase() in {input: 1, select: 1, textarea: 1, button: 1})) {
			continue;

		} else if (elem.type === 'radio') {
			if (radios[elem.name]) {
				continue;
			}
			radios[elem.name] = true;
		}

		if ((scope && !elem.name.replace(/]\[|\[|]|$/g, '-').match(scope)) || Nette.isDisabled(elem)) {
			continue;
		}

		if (!Nette.validateControl(elem, null, onlyCheck) && !Nette.formErrors.length) {
			return false;
		}
		else if (!Nette.formErrors.length) {
			let $element = $(elem);
			$element.parents('smart-input').find('[data-error-message]').removeAttr();
			$element.parents('smart-input').find('smart-input-error-message').remove();
			$element.parents('smart-input').removeClass('error').find('.error').removeClass('error');
		}
	}
	var success = !Nette.formErrors.length;
	Nette.showFormErrors(form, Nette.formErrors);
	return success;
};

Nette.addError = function(elem, message) {
	let $formElement = $(elem);

	if (
		$formElement.attr('type') === 'number'
		&& message === Nette.invalidNumberMessage
		&& $formElement.attr('step') !== undefined
		&& $formElement.attr('data-previous-and-next-step') !== undefined
		&& $formElement.attr('data-previous-step') !== undefined
	) {
		let previousValue = Math.round(Math.floor(Math.round($formElement.val() / $formElement.attr('step') * 10000) / 10000) * $formElement.attr('step') * 10000) / 10000;
		let nextValue = Math.round(Math.ceil(Math.round($formElement.val() / $formElement.attr('step') * 10000) / 10000) * $formElement.attr('step') * 10000) / 10000;

		if ($formElement.attr('min') > previousValue) {
			previousValue = Math.round(Math.ceil(Math.round($formElement.attr('min') / $formElement.attr('step') * 10000) / 10000) * $formElement.attr('step') * 10000) / 10000;
		}

		if ($formElement.attr('max') < nextValue) {
			nextValue = Math.round(Math.floor(Math.round($formElement.attr('max') / $formElement.attr('step') * 10000) / 10000) * $formElement.attr('step') * 10000) / 10000;
		}

		if (previousValue < nextValue) {
			message = $formElement.attr('data-previous-and-next-step')
				.replace('%previousValue%', previousValue)
				.replace('%nextValue%', nextValue);
		}
		else {
			message = $formElement.attr('data-previous-step').replace('%previousValue%', previousValue);
		}
	}

	$formElement.addClass('error');
	$formElement.data('error-message', message);

	let $smartInput             = $formElement.parents('smart-input').addClass('error');
	let $smartInputErrorMessage = $smartInput.find('smart-input-error-message');

	// Fix for radio list and checkbox list
	$smartInput.find('input[type=radio], input[type=checkbox]').addClass('error');

	if ($smartInputErrorMessage.length) {
		$smartInputErrorMessage.html(message);
	}
	else {
		$smartInput.append('<smart-input-error-message>' + message + '</smart-input-error-message>');
	}

	Nette.formErrors.push({
		element: elem,
		message: message
	});
};

Nette.showFormErrors = function(form, errors) {
	if (errors.length === 0) {
		let $form = $(form);

		$form.find('smart-input-error-message').remove();
		$form.find('[data-error-message]').removeAttr();
		$form.find('.error').removeClass('error');

		return;
	}

	let $formElement = $(errors[0].element);

	if ($formElement.attr('type') === 'radio') {
		$('input[name="' + $formElement.attr('name') + '"]:not(:disabled)').first().focus();
	}
	else {
		$formElement.focus();
	}

	$.flashMessenger.createFlashMessage(errors[0].message, 'error', 5000);
};

// Json
Nette.validators['AppFormsValidator_validateJson'] = (elem, args, val) => {
	try {
		JSON.parse(val);
	}
	catch(err) {
		return false;
	}

	return true;
};

Nette.validators['AppFormsValidator_validateJsonMaxLength'] = (elem, args, val) => {
	return val.length <= args;
};

// Wysiwyg
if (typeof tinymce === 'object') {
	tinymce.init({
		selector: "textarea[data-type=\"text:wysiwyg\"]",
		language: document.getElementsByTagName('html')[0].getAttribute('lang'),
		menubar:  false,
		extended_valid_elements: "span",
		entity_encoding : "named",
		entities: '160,nbsp,38,amp,60,lt,62,gt',
		plugins:  "link code lists",
		toolbar:  "undo redo | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent | link removeformat code",
		setup:    function (editor) {
			editor.on('change', function (e) {
				document.getElementById(editor.id).value = editor.getContent();
			});
		}
	});
}

// Image preview
if (typeof $ === 'function') {
	$('label.file-preview').each(function () {
		var $filePreview = $(this);
		$('#' + $filePreview.attr('for')).change(function (event) {
			var $image, $span, spantext, file;
			$image = $filePreview.find('img');
			if ($image.length === 0) {
				$image = $('<img>');
				$filePreview.append($image);
			}
			if (event.target.files.length > 0) {
				$filePreview.find('source').remove();
				file = new File([event.target.files[0]], event.target.files[0].name);
				$image.attr('src', URL.createObjectURL(file));
			}
			else { $image.remove(); }
			$span = $filePreview.find('span');
			spantext = $span.html();
			$span.remove();
			$filePreview.append('<span> ' + spantext + '</span>');
		});
	});
}

// Default datetime picker
if (typeof $ === 'function' && typeof $.datetimepicker === 'object') {
	$.datetimepicker.setLocale($('html').attr('lang'));

	$('input[data-type=\"datetime\"]').datetimepicker({
		format:     'Y-m-d H:i',
		formatDate: 'Y-m-d',
	});
}

// Default color picker
if (typeof $ === 'function' && typeof $.spectrum === 'object') {
	// Other options http://bgrins.github.io/spectrum/
	$("input[data-type=color][required]").spectrum({
		// color: tinycolor,
		// flat: true,
		showInput: true,
		showInitial: true,
		cancelText: 'Zrušit',
		chooseText: 'Vybrat',
		containerClassName: 'colorpicker-container',
		replacerClassName: 'colorpicker-replacer',
		preferredFormat: 'hex',
	});

	$("input[data-type=color]:not([required])").spectrum({
		// color: tinycolor,
		// flat: true,
		allowEmpty: true,
		showInput: true,
		showInitial: true,
		cancelText: 'Zrušit',
		chooseText: 'Vybrat',
		clearText: 'Bez barvy',
		containerClassName: 'colorpicker-container',
		replacerClassName: 'colorpicker-replacer',
		preferredFormat: 'hex',
	});
}



$(document).ready(function(){
	let validateControl = function ($element) {
		clearTimeout(Nette.validateControlTimer[$element.attr('id')]);

		Nette.validateControlTimer[$element.attr('id')] = setTimeout(function () {
			if (Nette.validateControl($element[0])) {
				$element.parents('smart-input').find('[data-error-message]').removeAttr();
				$element.parents('smart-input').find('smart-input-error-message').remove();
				$element.parents('smart-input').removeClass('error').find('.error').removeClass('error');
			}
		}, 250);
	};

	$('smart-input-eye-control').click(function () {
		let $input = $(this).parents('smart-input').find('input[type=text], input[type=password]');

		if ($input.attr('type') === 'password') {
			$input.attr('type', 'text');
		}
		else {
			$input.attr('type', 'password');
		}
	});

	$('label, smart-input-eye-control').on('selectstart', function () {return false;});

	$(document).on('keydown', 'input[type!=radio], input[type!=checkbox], textarea', function(){
		clearTimeout(Nette.validateControlTimer[$(this).attr('id')]);
	});

	$(document).on('keyup', 'input[type!=submit], textarea, select', function (event) {
		let keyCode = event.which || event.keyCode;

		if (keyCode === 13) {
			$(this).addClass('blured');
		}
	});

	$(document).on('keyup', 'input.blured, textarea.blured, input.error, textarea.error', function(){
		validateControl($(this));
	});

	$(document).on('blur', 'input[type=text], input[type=password], input[type=number], input[type=email], input[type=url], input[type=date], input[type=datetime-local], textarea', function(){
		let $this = $(this);
		$this.addClass('blured');
		validateControl($this);
	});

	$(document).on('blur, change', 'select', function(){
		validateControl($(this));
	});

	$(document).on('blur, change, click', 'input[type=radio], input[type=checkbox]', function() {
		validateControl($(this));
	});
});
